import styled from 'styled-components';

import Icon from '/components/ui/Icon';
import Heading from '/components/ui/Heading';
import { effects } from '/css';

const SpotonPriceInfo = () => {
    return (
        <Wrapper className="pt-32 pl-24 pr-24 pb-24">
            <div>
                <Icon icon="spoton" className="mb-16 icon" />
                <Heading small centered className="mb-24">
                    Du er helt trygg med <br />
                    vår SpotOnGaranti™
                </Heading>
            </div>
            <div className="img">
                <img
                    src="/images/illustrations/warranty-white.svg"
                    title="Fastpris"
                    alt="Fastpris"
                />
            </div>
        </Wrapper>
    );
};

export default SpotonPriceInfo;

const Wrapper = styled.div`
    background: #fff;
    ${effects.shadow};
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    .icon {
        margin-left: auto;
        margin-right: auto;
        display: block;
        width: 32px;
        height: 32px;
    }
    img {
        border-radius: 12px;
        overflow: hidden;
    }
    @media (max-width: 767px) {
        padding: 35px 25px !important;
        h5 {
            font-size: 26px !important;
            line-height: 34px !important;
        }
    }
`;
